export default "__VITE_ASSET__38915dc8__"